import { useFetchMessagingROIOOverview } from '../hooks/use-fetch-messaging-roi-overview';
import { MessagingOverview } from '../types';

export const messagingOverviewFormatter = (
  aggregated: ReturnType<typeof useFetchMessagingROIOOverview>['aggregated']
): MessagingOverview => {
  // Leads
  const leadsNewPatients = aggregated?.leadsContacted?.newPatientsCounts || 0;
  const leadsExistingPatients = aggregated?.leadsContacted?.existingPatientsCounts || 0;
  const leadsUnscheduledPatients = aggregated?.leadsContacted?.unscheduledPatientsCounts || 0;

  // Patients Scheduled
  const scheduledNewPatients = aggregated?.patientsScheduled?.newPatientsCounts || 0;
  const scheduledExistingPatients = aggregated?.patientsScheduled?.existingPatientsCounts || 0;

  // Patients Completed
  const newPatientsCompletedAppts = aggregated?.appointmentsCompleted?.newPatientsApptsCounts || 0;
  const existingPatientsCompletedAppts = aggregated?.appointmentsCompleted?.existingPatientsApptsCounts || 0;

  return {
    leadsContacted: {
      newPatients: leadsNewPatients,
      existingPatients: leadsExistingPatients,
      unsheduledPatients: leadsUnscheduledPatients,
      totalPatients: leadsNewPatients + leadsExistingPatients + leadsUnscheduledPatients,
      messagesSent: aggregated?.leadsContacted?.smsCount || 0,
    },
    patientsScheduled: {
      newPatients: scheduledNewPatients,
      existingPatients: scheduledExistingPatients,
      totalPatients: scheduledNewPatients + scheduledExistingPatients,
      appointmentsScheduledCount: aggregated?.patientsScheduled?.appointmentsCount || 0,
    },
    revenueGenerated: {
      newPatientsCompletedAppts,
      existingPatientsCompletedAppts,
      totalCompletedAppts: newPatientsCompletedAppts + existingPatientsCompletedAppts,
    },
  };
};
